import React from 'react';
import './index.css';
import clsx from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import { getPageList } from '../config';
import { useAppContext } from 'context';

const Position = ({ list, firstType }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const pageList = getPageList(pathname);
  const { dispatch } = useAppContext();

  const onClick = (v, index) => {
    const position = pageList.find((item) => v?.includes(item.name));
    // 当点击产品中心默认设置第一个产品类
    if (v === '产品中心') {
      dispatch({ type: 'SET_PRODUCT_TYPE', payload: firstType });
      // 不在产品中心页面时才跳转
      if (pathname !== '/productCenter') history.push('/productCenter');
      return;
    }
    // 当包含产品中心路由并通过前判断时（index>0,除首页），表示当前路由为产品详情，点击顶部产品类可返回产品中心页面 -- 其它正常
    const isHave = pathname?.includes('/productCenter') && index > 0;
    if (list.length !== index + 1 || isHave) {
      const url = isHave ? '/productCenter' : position?.path;
      history.push(url);
    }
  };

  return (
    <div className={clsx('position')}>
      <div className={clsx('position-content')}>
        您现在的位置：
        {list.map((item, index) => (
          <div
            key={index}
            className={clsx('position-content-item')}
            onClick={() => onClick(item, index)}
          >
            <span className={clsx('position-content-item-text')}>{item}</span>
            {index !== list.length - 1 && (
              <svg
                viewBox='64 64 896 896'
                focusable='false'
                data-icon='right'
                width='10px'
                height='10px'
                fill='currentColor'
                aria-hidden='true'
                className={clsx('position-svg')}
              >
                <path d='M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z'></path>
              </svg>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Position;
